// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"Dashboard_FullWidth__1EoKA","FormLabel":"Dashboard_FormLabel__1HQCK","Title":"Dashboard_Title__1kODf"};